import gql from 'graphql-tag';

export const MOVE_RUN_TO_GROUP = gql`
  mutation MoveRunToGroup(
    $entityName: String!
    $groupName: String!
    $projectName: String!
    $runId: String!
  ) {
    upsertBucket(
      input: {
        entityName: $entityName
        groupName: $groupName
        id: $runId
        modelName: $projectName
      }
    ) {
      bucket {
        id
        group
      }
    }
  }
`;
